import LayoutPage from "../../Components/LayoutPage";
import DollarContainer from "./Components/DollarContainer";

export default function Dollar() {
  
  return (
    <LayoutPage
      activeIndex={19}
      navItems={["مدیریت قیمت دلار"]}
      childrenClassName="flex-1 min-h-0 flex flex-col items-center gap-5 overflow-auto"
    >
      <DollarContainer />
    </LayoutPage>
  );
}
